import axios from "@/config/httpConfig";

/**
 * OSS文件管理相关API
 */
const modelName = "oss"

/**
 * 获取文件列表（分页）
 * @param data 查询参数
 * @returns {Promise<unknown>}
 */
export function getOssFilePage(data) {
    return axios.post("/" + modelName + "/file/page", data)
}

/**
 * 获取文件列表
 * @param data 查询参数
 * @returns {Promise<unknown>}
 */
export function getOssFileList(data) {
    return axios.get("/" + modelName + "/file/list", {
        params: data.param
    })
}

/**
 * 上传文件
 * @param formData 表单数据
 * @returns {Promise<unknown>}
 */
export function uploadOssFile(formData) {
    return axios.post("/" + modelName + "/file/upload", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * 下载文件
 * @param objectKey 文件路径
 * @returns {Promise<unknown>}
 */
export function downloadOssFile(objectKey) {
    return axios.get("/" + modelName + "/file/download/" + objectKey, null, {
        responseType: 'blob'
    })
}

/**
 * 复制文件
 * @param data 复制参数
 * @returns {Promise<unknown>}
 */
export function copyOssFile(data) {
    return axios.post("/" + modelName + "/file/copy", data)
}

/**
 * 删除文件
 * @param objectKey 文件路径
 * @returns {Promise<unknown>}
 */
export function deleteOssFile(objectKey) {
    return axios.delete("/" + modelName + "/file/" + objectKey)
}

/**
 * 批量删除文件
 * @param objectKeys 文件路径列表
 * @returns {Promise<unknown>}
 */
export function deleteBatchOssFile(objectKeys) {
    return axios.delete("/" + modelName + "/file/batch", {
        data: objectKeys
    })
}

/**
 * 获取文件预签名URL
 * @param objectKey 文件路径
 * @param params 额外参数
 * @returns {Promise<unknown>}
 */
export function getOssFilePresignedUrl(objectKey, params) {
    return axios.get("/" + modelName + "/file/presigned-url/" + objectKey, params)
}
